import { ADMIN, COMMON, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

export const soundApi = {
  bgmDropList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'dropdownPlatformSound',
        project_id: projectId,
      })
      .then((res) => {
        const newArr = [];
        res?.data?.map((v, i) =>
          newArr.push({
            key: i,
            value: v.sound_id,
            text: v.sound_name,
          }),
        );
        return newArr;
      }),
};

export const soundManagementList = async () => {
  try {
    const res = await ifyouApi.get(`${ADMIN}/sound-management-list`);
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

// 로비 및 플레이 팝업 BGM
export const fetchBgmDropList = async (project_id) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'dropdownPlatformSound',
      project_id: project_id,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const fetchSeDropList = async () => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'dropdownPlatformSound',
      project_id: -1,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const soundManagementUpdate = async (inputData) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/sound-management-update`, {
      main_bgm_project_id: inputData.main_bgm_project_id,
      main_bgm_sound_id: inputData.main_bgm_sound_id,
      positive_sound_id: inputData.positive_sound_id,
      negative_sound_id: inputData.negative_sound_id,
      claim_sound_id: inputData.claim_sound_id,
      exp_up_sound_id: inputData.exp_up_sound_id,
      item_sound_id: inputData.item_sound_id,
      waiting_sound_id: inputData.waiting_sound_id,
      grade_up_sound_id: inputData.grade_up_sound_id,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
